module.exports = __webpack_public_path__ + "static/img/bs.76c01983.svg";